import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay, Button, Container, HStack, Text, VStack
} from "@chakra-ui/react";
import React, {useRef} from "react";
import {useDialogStore} from "../../../store/useAlertDialog";

export const BaseDialog = () => {
    const {dialogModel, closeDialog} = useDialogStore();
    const cancelRef = useRef<HTMLButtonElement>(null);
    const {
        title,
        description,
        buttons,
        confirmButtonText,
        cancelButtonText,
        onPressCancelButton,
        onConfirmButtonClick,
        children
    } = dialogModel || {};

    return <AlertDialog
        isOpen={!!dialogModel}
        leastDestructiveRef={cancelRef}
        onClose={closeDialog}
    >
        <AlertDialogOverlay>
            <AlertDialogContent>
                {/*{title && <AlertDialogHeader fontSize='lg' fontWeight='bold'>*/}
                {/*    {title}*/}
                {/*</AlertDialogHeader>}*/}

                <AlertDialogBody>
                    <VStack alignItems={'flex-start'}>
                        {title && <Text fontSize={'lg'} fontWeight={'bold'}>{title}</Text>}
                        <VStack w={'100%'} gap={4}>
                            {description && <Text dangerouslySetInnerHTML={{__html: description}}/>}
                            {children && children}
                        </VStack>
                    </VStack>
                </AlertDialogBody>

                {(cancelButtonText || confirmButtonText) && <AlertDialogFooter>
                    <HStack w={'100%'} gap={2}>
                        {buttons && buttons({isPending: false, closeDialog})}
                        {cancelButtonText &&
                            <Button onClick={() => {
                                closeDialog();
                                onPressCancelButton?.();
                            }} flex={1} cursor={'pointer'} color={'primary.400'}>
                                {cancelButtonText}
                            </Button>}
                        {confirmButtonText &&
                            <Button
                                onClick={onConfirmButtonClick}
                                flex={1}
                                cursor={'pointer'}
                                bg={'primary.400'}
                                color={'white'}
                                _hover={{bg: 'primary.500'}}
                                _active={{bg: 'primary.500'}}
                            >
                                {confirmButtonText}
                            </Button>}
                    </HStack>
                </AlertDialogFooter>}
            </AlertDialogContent>
        </AlertDialogOverlay>
    </AlertDialog>;
}
